import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes';

import store from './plugin/store'
import Gravatar from 'vue-gravatar';

Vue.component('v-gravatar', Gravatar);
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
 
Vue.component('apexchart', VueApexCharts)
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
const socket = io('https://api.dm.itmaster.dk/admin',{
  autoConnect: true,
  query: {
    token: localStorage.token,
  }
});
Vue.use(VueSocketIOExt, socket);

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes
});
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')